export const checkIfPaymentIsPossibleByStatus = (status: string | undefined): boolean => {
  if (!status) {
    return false;
  }

  return /new|payment failed|pending payment/i.test(status);
};
